import { validatePhone } from "@stepapp/core";
import { useTranslation } from "react-i18next";
import { boolean, object, string } from "zod";
import { AppStorage } from "../services/AppStorage";

export const useRegisterFormSchema = ({ isRegister = false }: { isRegister?: boolean }) => {
  const { t } = useTranslation();

  const registerSchema = object({
    phoneNumber: string().refine((v) => validatePhone(v, AppStorage().get("countryCode")), {
      message: t("validation.phone"),
    }),
    code: string().optional().nullable(),
    otpCodeVerified: boolean(),
    ...(isRegister && {
      email: string().trim().email(t("validation.email")),
      firstName: string().min(1, t("validation.firstName")),
      lastName: string().min(1, t("validation.lastName")),
    }),
  });
  return registerSchema;
};

export const useEmailSchema = () => {
  const { t } = useTranslation();

  const emailSchema = object({
    email: string().trim().email(t("validation.email")),
  });
  return emailSchema;
};
